import { Component, Input } from '@angular/core';
import { RouterLink, RouterModule } from '@angular/router';

@Component({
  selector: 'app-buy-now-button',
  imports: [RouterModule, RouterLink],
  templateUrl: './buy-now-button.component.html',
  styleUrl: './buy-now-button.component.scss'
})
export class BuyNowButtonComponent {
}
